"use strict";

require("./auth");
require("./change_password");
require("./commands");
require("./init");
require("./join");
require("./more");
require("./msg");
require("./msg_preview");
require("./msg_special");
require("./names");
require("./network");
require("./nick");
require("./open");
require("./part");
require("./quit");
require("./sync_sort");
require("./topic");
require("./users");
require("./sign_out");
require("./sessions_list");
require("./configuration");
require("./changelog");
require("./setting");
